import { forwardRef } from "react";
import { SVGFillPath, SVGIconRoot, SVGStrokePath } from "./SVGComponents";
import { IconProps } from "./index";

export const QuestionCircle = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => {
    return (
      <SVGIconRoot viewBox="0 0 38 38" ref={ref} {...props}>
        <SVGStrokePath
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 37C28.9411 37 37 28.9411 37 19C37 9.05887 28.9411 1 19 1C9.05887 1 1 9.05887 1 19C1 28.9411 9.05887 37 19 37Z"
        />
        <SVGFillPath d="M17.248 24.3311H21.0312V28H17.248V24.3311ZM12.6143 15.1904C12.7158 12.7783 13.5579 11.0687 15.1406 10.0615C16.1393 9.41829 17.3665 9.09668 18.8223 9.09668C20.735 9.09668 22.3219 9.55371 23.583 10.4678C24.8525 11.3818 25.4873 12.736 25.4873 14.5303C25.4873 15.6305 25.2122 16.5573 24.6621 17.3105C24.3405 17.7676 23.7227 18.3516 22.8086 19.0625L21.9072 19.7607C21.4163 20.1416 21.0905 20.5859 20.9297 21.0938C20.8281 21.4154 20.7731 21.9147 20.7646 22.5918H17.3369C17.3877 21.1615 17.5231 20.1755 17.7432 19.6338C17.9632 19.0837 18.5303 18.4531 19.4443 17.7422L20.3711 17.0186C20.6758 16.79 20.9212 16.5404 21.1074 16.2695C21.446 15.804 21.6152 15.292 21.6152 14.7334C21.6152 14.0902 21.4248 13.5062 21.0439 12.9814C20.6715 12.4482 19.986 12.1816 18.9873 12.1816C18.0055 12.1816 17.3073 12.5075 16.8926 13.1592C16.4863 13.8109 16.2832 14.488 16.2832 15.1904H12.6143Z" />
      </SVGIconRoot>
    );
  },
);
